import Updates from '@/pages/Updates'
export default {
    path: '',
    component: Updates,
    children: [
      {
        path: '/rc',
        name: 'Updates',
        component: Updates,
      },
      {
        path: '/deluxe',
        name: 'DeluxeUpdates',
        component: Updates,
      },
    ]
}


// WEBPACK FOOTER //
// ./src/router/updates.js